import React from "react";

/**
 * Switch between the generated PDF of a document and the EMR listing of its data.
 * Uses the app nav-tabs look (underline indicator) so it reads as part of the modal header.
 */
const PdfEmrViewToggle = ({pdfView, onChange, emrLabel = 'EMR VIEW', extraClass = ''}) => {
    const renderTab = (label, isActive, value) => (
        <li className="nav-item">
            <a className={`pointer nav-link ${isActive ? 'active' : ''}`}
               onClick={event => {
                   onChange(value);
                   event.preventDefault();
               }}>{label}</a>
        </li>
    )

    return (
        <ul className={`nav nav-tabs pdf-emr-toggle ${extraClass}`} role="tablist">
            {renderTab('PDF', pdfView, true)}
            {renderTab(emrLabel, !pdfView, false)}
        </ul>
    )
}

export default PdfEmrViewToggle;
